import React, { useCallback, useEffect } from "react";
import { MdDateRange } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { getRanks } from "../../../redux/services/reportSlice";
import { FaUser } from "react-icons/fa";
import { useUser } from "../../../redux/services/authSlice";

const Leaderboard = ({ contestId, qaId }) => {
  const getRankData = useSelector((state) => state?.report?.rankData);
  const dispatch = useDispatch();
  const { user } = useUser();
  const getReports = useCallback(async () => {
    try {
      await dispatch(getRanks({ qaId: qaId, contestId: contestId }));
    } catch (error) {}
  }, [dispatch, qaId, contestId]);

  useEffect(() => {
    getReports();
  }, [getReports]);
  const winnersList = getRankData[0]?.ranks
    .filter((item) => item?.startPlace && item?.endPlace)
    .flatMap((item) => item?.winners)
    .slice(1);
    const userRankData = getRankData[0]?.ranks
  .flatMap((item) => item?.winners)
  .find(
    (winner) =>
      winner?.firstName?.trim()?.toLowerCase() === user?.firstName?.trim()?.toLowerCase() &&
      winner?.lastName?.trim()?.toLowerCase() === user?.lastName?.trim()?.toLowerCase()
  );
  return (
    <>
      <div className="flex flex-col items-center justify-center bg-white text-black p-6">
        <div className="flex justify-center items-center w-full max-w-md mb-4">
          <div className="flex items-center gap-2 bg-green-100 px-4 py-2 rounded-lg text-sm font-semibold">
            <MdDateRange size={20} className="text-green-600" />
            {new Date().toLocaleDateString("en-GB").split("/").join("-")}
          </div>
        </div>

        <div className="bg-blue-100 text-blue-900 text-sm font-bold px-4 py-3 rounded-lg flex items-center gap-4">
          <div className="w-12 h-12 bg-[#124699] rounded-lg flex justify-center items-center">

          <p className="text-lg text-white">#{userRankData?.rank} </p>
          </div>
          <p className="text-lg">{user?.civilServiceType} {user?.firstName} {user?.lastName} </p>
   
        </div>

        <div className="flex justify-center items-end w-full max-w-md mt-24">
          {getRankData[0]?.ranks.map((player, index) => (
            <div
              key={index}
              className={`text-center ${
                parseInt(player?.startPlace) === 1
                  ? "order-2"
                  : parseInt(player?.startPlace) === 2
                  ? "order-1"
                  : "order-3"
              }`}
            >
              <div
                className={`relative text-white p-2 w-[80px]  ${
                  parseInt(player?.startPlace) === 1
                    ? "h-40 bg-[#53A47F]"
                    : "h-20 bg-[#F48224]"
                }`}
              >
                <div className="absolute top-[-65px] left-6">
                  <p className="text-black text-sm p-1 rounded-md">
                    {player?.winners[0]?.firstName}
                  </p>
                  <p className="bg-[#F48224]  text-sm p-1 rounded-md">
                    {player?.winners[0]?.points}
                  </p>
                </div>
                <p className="text-lg font-bold">{player?.startPlace}</p>
              </div>
              <p className="text-md font-semibold mt-2">{player?.name}</p>
            </div>
          ))}
        </div>

        <div className="mt-6 w-full max-w-md space-y-3">
          {winnersList?.map((player, index) => (
            <div
              key={index}
              className="bg-gray-100 flex md:gap-7 gap-3 items-center px-4 py-3 rounded-lg shadow"
            >
              <div className="border border-black w-8 h-8 flex justify-center items-center rounded-full">
                <p className="font-semibold">{player?.rank} </p>
              </div>
              <div className="border bg-white w-12 h-12 flex justify-center items-center rounded-full">
                <FaUser size={20} />
              </div>

              <div>
                <p className="font-semibold">
                  {player?.firstName} {player?.lastName} 
                </p>
                <p className="font-medium text-sm text-gray-600">
                  {player?.rank}th Rank
                </p>
              </div>
              <p className="text-lg">{player?.flag}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Leaderboard;
